import { useState } from "react";
import { Table, ConfigProvider } from "antd";
import { useBusesQuery } from "src/services/react-query-apis/get-buses";
import { getCurrentMonth } from "src/services/auth/token";
import moment from "moment";
import BusUpdateButton from "./bus-update-button";
import BusDeleteButton from "./bus-delete-button";
import BusAddButton from "./bus-add-button";

const currentMonth = moment(getCurrentMonth()).format("YYYY-MM");
const nextMonth = moment(getCurrentMonth()).add(1, "month").format("YYYY-MM");

const customTheme = {
  components: {
    Table: {
      rowHoverBg: "#D6EAF8",
    },
  },
};

const Buses = () => {
  const [selectedBusId, setSelectedBusId] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth || null);

  const busesQuery = useBusesQuery({ month: selectedMonth });

  const isNextMonth = selectedMonth === nextMonth;

  const columns = [
    {
      title: "バス名",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "定員",
      dataIndex: "capacity",
      key: "capacity",
      width: 100,
      align: "center",
    },
    {
      title: "操作",
      key: "action",
      width: "100px",
      align: "center",
      render: (_, record) => (
        <div className="d-flex justify-content-center align-items-center gap-2">
          {isNextMonth && (
            <>
              <BusUpdateButton bus={record} />
              <BusDeleteButton bus={record} />
            </>
          )}
        </div>
      ),
    },
  ];

  const rowClassName = r => (r.id === selectedBusId ? "selected-row" : "");

  return (
    <div style={{ width: "65%" }}>
      <div className="card-body">
        <div className="card">
          <div className="card-header d-flex align-items-center">
            <div style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
              バス一覧
            </div>
            <div className="d-flex align-items-center gap-2 mx-4">
              <label>処理年月:</label>
              <input
                type="month"
                value={selectedMonth}
                onChange={e => setSelectedMonth(e.target.value)}
                min={currentMonth}
                max={nextMonth}
              />
            </div>
            {isNextMonth && (
              <BusAddButton
                onSuccess={busId => {
                  setSelectedBusId(busId);
                }}
              />
            )}
          </div>
        </div>

        <div style={{ marginTop: "10px" }}>
          <ConfigProvider theme={customTheme}>
            <Table
              bordered
              dataSource={busesQuery.data?.data || []}
              columns={columns}
              loading={busesQuery.isLoading}
              rowKey="id"
              pagination={false}
              rowClassName={rowClassName}
              onRow={record => ({
                onClick: () =>
                  setSelectedBusId(b => (b === record.id ? null : record.id)),
              })}
              locale={{
                emptyText: busesQuery.error
                  ? "バスデータの取得に失敗しました"
                  : "バスデータがありません",
              }}
            />
          </ConfigProvider>
        </div>
      </div>
    </div>
  );
};

export default Buses;
